import type { TIconProps } from "./types";

export const DeepSeek = (props: TIconProps) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 0L12 4L8 8L4 4L8 0Z" fill="#4D6BFE" />
      <path d="M8 8L12 12L8 16L4 12L8 8Z" fill="#4D6BFE" />
      <path d="M4 4L8 8L4 12L0 8L4 4Z" fill="#4D6BFE" opacity="0.7" />
      <path d="M12 4L16 8L12 12L8 8L12 4Z" fill="#4D6BFE" opacity="0.7" />
      <circle cx="8" cy="8" r="1.5" fill="#4D6BFE" opacity="0.5" />
    </svg>
  );
};
